import * as React from "react";
import type { SVGProps } from "react";
const SvgAccountswitchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="accountswitch_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M189.61 91.008A189.61 189.61 0 0 0 0 280.661v455.083a189.61 189.61 0 0 0 189.61 189.653h455.126a37.93 37.93 0 0 0 0-75.861H189.611A113.792 113.792 0 0 1 75.86 735.744V280.661a113.792 113.792 0 0 1 113.75-113.834h417.194a113.792 113.792 0 0 1 113.792 113.792v37.93a37.93 37.93 0 0 0 75.862 0v-37.973a189.61 189.61 0 0 0-189.654-189.61H189.611zm303.446 303.403a75.861 75.861 0 1 0-151.723 0 75.861 75.861 0 0 0 151.723 0zm75.819 0c0 38.826-14.592 74.24-38.571 101.12 25.6 12.074 49.024 28.16 69.333 47.36a37.93 37.93 0 0 1-52.138 55.125A189.61 189.61 0 0 0 227.54 735.744a37.93 37.93 0 0 1-75.818 0 265.515 265.515 0 0 1 152.32-240.213 151.723 151.723 0 1 1 264.832-101.12zm417.194 161.834H767.061l59.136-59.136a37.93 37.93 0 0 0-53.632-53.632L655.872 560.171a37.845 37.845 0 0 0-10.965 30.378 37.93 37.93 0 0 0 37.76 41.558h303.402a37.93 37.93 0 0 0 0-75.862zM1024 727.68a39.253 39.253 0 0 1-.17 3.627 37.845 37.845 0 0 1-10.923 30.378L896.213 878.38a37.93 37.93 0 1 1-53.674-53.632l59.136-59.136H682.667a37.93 37.93 0 1 1 0-75.862h303.402c20.95 0 37.931 16.982 37.931 37.931z"
    />
  </svg>
);
export default SvgAccountswitchIcon;
